import React from 'react';
import { Colors as C } from '../../constants/Colors.js';
import logo from '../../logo.jpg';

/**
 * Mensaje de bienvenida tras superar el gate beta (una vez por navegador).
 * @param {{ onDismiss: () => void }} props
 */
export default function BetaWelcomeSplash({ onDismiss }) {
  return (
    <div
      role="dialog"
      aria-labelledby="beta-welcome-title"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 1001,
        background: '#050507',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20,
        touchAction: 'manipulation',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 20,
          right: 20,
          background: 'rgba(200,168,75,0.12)',
          border: '1px solid rgba(200,168,75,0.35)',
          borderRadius: 8,
          padding: '6px 12px',
          color: C.gold,
          fontWeight: 700,
          fontSize: '0.75rem',
          letterSpacing: 0.5,
        }}
      >
        ACCESO ANTICIPADO
      </div>

      <div
        style={{
          width: 'min(560px, 92vw)',
          maxHeight: '86vh',
          overflow: 'auto',
          padding: '18px 16px',
          borderRadius: 16,
          border: '1px solid rgba(255,255,255,0.08)',
          background: 'rgba(8,8,12,0.78)',
          backdropFilter: 'blur(10px)',
          textAlign: 'center',
          color: '#fff',
        }}
      >
        <img
          src={logo}
          alt="DreamVinyl"
          style={{
            width: 'clamp(96px, 22vw, 120px)',
            borderRadius: 16,
            marginBottom: 16,
            boxShadow: '0 0 40px rgba(200,168,75,0.18)',
            border: '1px solid rgba(200,168,75,0.22)',
          }}
        />

        <h1
          id="beta-welcome-title"
          style={{
            margin: '0 0 12px',
            fontSize: 'clamp(1.45rem, 4.5vw, 1.85rem)',
            fontWeight: 900,
            lineHeight: 1.25,
          }}
        >
          ¡Felicidades! <span style={{ color: C.gold }}>Ya estás dentro</span>
        </h1>

        <p style={{ color: 'rgba(255,255,255,0.72)', lineHeight: 1.65, margin: '0 0 14px', fontSize: 'clamp(0.9rem, 2.8vw, 0.98rem)' }}>
          A partir de ahora eres de los primeros en entrar al universo{' '}
          <strong style={{ color: '#fff' }}>DreamVinyl</strong> y descubrir todo lo que estamos
          preparando para quienes viven la música.
        </p>

        <p style={{ color: 'rgba(255,255,255,0.58)', lineHeight: 1.6, margin: '0 0 14px', fontSize: 'clamp(0.84rem, 2.6vw, 0.92rem)' }}>
          <strong style={{ color: C.goldLight }}>Perteneces a la beta:</strong> regístrate como usuario o solicita tu
          perfil <strong>Partner</strong>. Los <strong>primeros 100 registros</strong> tendrán ventajas exclusivas que
          no repetiremos cuando abramos al público.
        </p>

        <p style={{ color: 'rgba(255,255,255,0.45)', lineHeight: 1.55, margin: '0 0 18px', fontSize: 'clamp(0.8rem, 2.5vw, 0.88rem)' }}>
          En esta fase puedes explorar el <strong style={{ color: 'rgba(255,255,255,0.65)' }}>marketplace</strong>,{' '}
          <strong style={{ color: 'rgba(255,255,255,0.65)' }}>publicar tus discos</strong> (venta simple y chat), leer las{' '}
          <strong style={{ color: 'rgba(255,255,255,0.65)' }}>noticias</strong>, participar en la{' '}
          <strong style={{ color: 'rgba(255,255,255,0.65)' }}>comunidad</strong> y usar el{' '}
          <strong style={{ color: 'rgba(255,255,255,0.65)' }}>chat</strong>. También puedes conseguir{' '}
          <strong style={{ color: C.goldLight }}>Grooves</strong> completando objetivos y usarlos en la plataforma (sin
          compra con dinero en esta fase).
        </p>

        <p style={{ color: C.gold, lineHeight: 1.45, margin: '0 0 18px', fontSize: 'clamp(0.82rem, 2.5vw, 0.92rem)', fontWeight: 800 }}>
          ¿Tienes vinilos en casa? Sube ya tus discos y sé de los primeros en dejar huella en el surco.
        </p>

        <p style={{ color: 'rgba(255,255,255,0.38)', lineHeight: 1.5, margin: '0 0 18px', fontSize: 'clamp(0.74rem, 2.3vw, 0.84rem)' }}>
          Pagos, subastas y compra de Grooves llegarán en los próximos pasos del lanzamiento.
        </p>

        <p style={{ color: 'rgba(255,255,255,0.38)', lineHeight: 1.5, margin: '0 0 24px', fontSize: '0.8rem', fontStyle: 'italic' }}>
          Hemos puesto mucho corazón en este proyecto — esperamos que te encante tanto como a nosotros crearlo.
        </p>

        <button
          type="button"
          className="splash-btn"
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            onDismiss?.();
          }}
          style={{
            background: C.gold,
            color: '#000',
            border: 'none',
              padding: '14px 22px',
            borderRadius: 4,
            fontWeight: 900,
            fontSize: '0.92rem',
            cursor: 'pointer',
            letterSpacing: 0.5,
              width: 'min(340px, 100%)',
          }}
        >
          EXPLORAR DREAMVINYL →
        </button>
      </div>
    </div>
  );
}
